export function scrollDown() {
    $(".scroll-down-button").on("click", function () {
        let $window = $(window);
        let top = $(this).closest(".hero-section").innerHeight();
        const next = $(this).parents(".hero-section").siblings("div, section").eq(0);
        const point = 1440;
        if (next.length) {
            top = next.children().eq(0).offset().top - ($window.width() < point ? 40 : 80);
        }
        $('html, body').animate({
            scrollTop: top
        }, 700);
        return false;
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollDown.js